module.exports = __webpack_public_path__ + "static/media/scape.bb3759ca.png";